<template>
  <div>
    <div class="bg-white w-full flex flex-col h-32 border rounded border-gray-500" @click="setEditMode()">
      <div class="flex items-center justify-center" :class="textColorClass">
        <div class="w-1/5 icon-size text-center">
          <zt-icon name="camera" />
        </div>
        <div class="w-3/5 text-size pl-2">
          <span>{{ $t("message.FileUploadComponent.formComponent.takeAPhoto") }}</span>
        </div>
        <div class="w-1/5 icon-size text-center">
          <zt-icon name="angle-right" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  inject: ['state', 'mutations'],
  props: ['openWindow'],
  data() {
    return {}
  },
  computed: {
    isInIframe() {
      return window.self !== window.top;
    },
    textColorClass() {
      return this.isInIframe ? 'text-iframe-primary' : 'text-zt-primary-200';
    }
  },
  methods: {
    setEditMode() {
      this.mutations.setEditMode(true)
      this.openWindow()
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-size {
  font-size: 2rem;
}

.text-size {
  font-size: 1rem;
}

.text-iframe-primary {
  color: #2694fc !important;
}
</style>